import React, { useState } from 'react';
import { Check, Link2 } from 'lucide-react';
import { PUBLIC_SITE_URL } from '../../data/site';
type CopyLinkButtonProps = {
  hash?: string;
  label?: string;
  iconOnly?: boolean;
};
export function CopyLinkButton({
  hash,
  label = 'Copiar enlace',
  iconOnly = false
}: CopyLinkButtonProps) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    const origin = PUBLIC_SITE_URL.replace(/\/+$/, '') || window.location.origin;
    const url = `${origin}${window.location.pathname}${window.location.search}${hash ? `#${hash}` : ''}`;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };
  const Icon = copied ? Check : Link2;
  const text = copied ? 'Enlace copiado' : label;
  if (iconOnly) {
    return <button type="button" onClick={copy} aria-label={text} title={text} className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ${copied ? 'text-[#D4AF37]' : 'text-gray-500 hover:bg-white/5 hover:text-white'}`} data-id="element-321" data-mp="8y32fioydj82">
        <Icon className="h-4 w-4" data-id="element-322" data-mp="401i6ufsjdv0" />
      </button>;
  }
  return <button type="button" onClick={copy} className="inline-flex h-10 items-center gap-2 rounded-full border border-white/15 px-4 text-sm font-semibold text-gray-200 whitespace-nowrap transition-colors duration-150 hover:border-[#D4AF37]/50 hover:text-white" data-id="element-323" data-mp="rqdzgvwxemy9">
      <Icon className={`h-4 w-4 ${copied ? 'text-[#D4AF37]' : ''}`} aria-hidden="true" data-id="element-324" data-mp="mpq8294sc43i" />
      <span aria-live="polite" data-id="element-325" data-mp="33f54ga0if70g">{text}</span>
    </button>;
}